export const Country = {
    CZ: 43
} as const

export type Country = typeof Country[keyof typeof Country]